import React from "react";
import { Badge, Tooltip } from "antd";
import { FolderOutlined, FolderOpenOutlined, FileOutlined } from "@ant-design/icons";
import ExamBankActions from "./ExamBankActions";

const ExamBankChildCard = ({
    child,
    onEdit,
    onDelete,
    onAddChild,
    onManageExams,
    onExpand,
    level = 1,
    isLoading = false,
    isExpanded = false,
}) => {
    return (
        <div
            className="mb-2 rounded-md hover:shadow-sm transition-shadow flex items-center justify-between pr-3 py-2"
            style={{
                marginRight: `${level * 20}px`,
                backgroundColor: level % 2 === 0 ? "#f9fafb" : "#f3f4f6",
                direction: "rtl",
            }}
        >
            {/* Right side: icon + title */}
            <div className="flex items-center gap-3">
                <Tooltip title={child.HasChildren ? (isExpanded ? "بستن" : "باز کردن") : "بدون فرزند"}>
                    {child.HasChildren ? (
                        isExpanded ? (
                            <FolderOpenOutlined
                                onClick={() => onExpand(child)}
                                className="cursor-pointer text-blue-700"
                                style={{ fontSize: "20px" }}
                            />
                        ) : (
                            <FolderOutlined
                                onClick={() => onExpand(child)}
                                className="cursor-pointer text-blue-500"
                                style={{ fontSize: "20px" }}
                            />
                        )
                    ) : (
                        <FileOutlined className="text-gray-400" style={{ fontSize: "20px" }} />
                    )}
                </Tooltip>
                <span className="font-medium">{child.Title}</span>
            </div>

            {/* Left side: numbers + action buttons */}
            <div className="flex items-center gap-4">
                <div className="flex gap-3">
                    <Badge count={child.ChildCount} showZero color="orange" title="تعداد فرزندان" />
                    <Badge count={child.UserCount} showZero color="green" title="تعداد کاربران" />
                    <Badge count={child.ExamCount} showZero color="blue" title="تعداد آزمون‌ها" />
                </div>
                <ExamBankActions
                    record={child}
                    onEdit={onEdit}
                    onDelete={onDelete}
                    onAddChild={onAddChild}
                    onManageExams={onManageExams}
                    showAddChild={true}
                    showManageExams={true}
                />
            </div>
        </div>
    );
};

export default ExamBankChildCard;